// extracted by css-extract-rspack-plugin
export default {"root":"RTH1EC","link":"fI5gVj"};